import { Injectable } from '@angular/core';
import {
  Data,
  Router,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  ActivatedRoute,
  Event,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PlRoutingService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  fullData(onEnd = false): Observable<Data> {
    const initialData: Data = this.getData();
    const source$: Observable<Data> = this.router.events.pipe(
      filter((event: Event) => {
        if (onEnd) {
          return this.isNavigationEnd(event);
        }
        return event instanceof RoutesRecognized;
      }),
      map(() => this.getData())
    );
    return source$.pipe(startWith<Data>(initialData));
  }

  private getData(): Data {
    let child = this.activatedRoute.snapshot;
    let data = {};
    while (child) {
      data = { ...data, ...child.data };
      child = child.firstChild;
    }
    return data;
  }

  private isNavigationEnd(event: Event): boolean {
    return (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    );
  }
}
